var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",staticStyle:{"border-bottom":"1px solid #dfdfdf"},style:(_vm.lineStyle)})}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlVue/go-line.vue